import { createSelector } from '@ngrx/store';
import { getAppFeatureState } from '@appState/reducers/app.reducer';
import { getLocaleCurrencyName } from '@angular/common';

// export const getItemState = createSelector(
//  fromFeature.getProfileFeatureState,
//  (state: fromFeature.ProductsAdminState) => state.items
// );

export const getSiteConfig = createSelector(
  getAppFeatureState,
  state => state.config
);

export const getUserProfile = createSelector(getSiteConfig, state => {
  return state.userProfile;
});

export const getHasVerifiedSSN = createSelector(getAppFeatureState, state => {
  return state.hasVerifiedSSN;
});

export const getStockPlanUri = createSelector(
  getSiteConfig,
  state => state.stockPlanUri
);

export const getSupportEmailAddress = createSelector(
  getSiteConfig,
  state => state.supportEmailAddress
);

export const getIsAdminOnlyMode = createSelector(getSiteConfig, state => {
  return state.isAdminOnlyMode;
});

export const getAreShareholdersAccessible = createSelector(
  getSiteConfig,
  state => {
    const userProfile = state.userProfile;
    const isAdminOnlyMode = state.isAdminOnlyMode;

    return (
      userProfile.isAdmin ||
      (!isAdminOnlyMode &&
        (userProfile.isOfficer || userProfile.hasSubordinates))
    );
  }
);
